module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kp1Mc"))).then(() => parcelRequire('d4u6f'));